import { all, takeLatest, put, call } from 'redux-saga/effects';

import cookie from '@snapask/common-components/dist/utils/cookie';

import { openExternalUrl } from '@dragonfruit/redux/navigation';
import { loginSuccess } from '@dragonfruit/redux/auth';
import * as actions from '@dragonfruit/redux/confirmEmail';
import { storeProfile } from '@dragonfruit/redux/profile';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';

import {
  PREVIOUS_PURCHASE_PAGE,
  PREVIOUS_SSO_LOGIN_PAGE,
} from '@dragonfruit/constants/cookieNames';
import {
  COMPLETE_REGISTRATION,
  EVENT_COMPLETED_REGISTRATION,
} from '@dragonfruit/constants/gtmEvents';
import { EMAIL } from '@dragonfruit/constants/signupAuthType';
import {
  apiCheckUpdatedEmailToken,
  apiCheckConfirmEmailToken,
} from '@dragonfruit/services/apis';

import config from '@dragonfruit/config';
const { COOKIE_DOMAIN } = config;

const AFTER_SIGNUP_REDIRECT_COOKIE_NAME_LIST = [
  PREVIOUS_PURCHASE_PAGE,
  PREVIOUS_SSO_LOGIN_PAGE,
];

function getRedirectPage() {
  const snapCookie = new cookie(COOKIE_DOMAIN);

  for (
    let listIndex = 0;
    listIndex < AFTER_SIGNUP_REDIRECT_COOKIE_NAME_LIST.length;
    listIndex++
  ) {
    const cookieName = AFTER_SIGNUP_REDIRECT_COOKIE_NAME_LIST[listIndex];
    const redirectPage = snapCookie.readCookie(cookieName);
    if (redirectPage) {
      snapCookie.deleteCookie(cookieName);
      return redirectPage;
    }
  }

  return false;
}

export function* confirmRegisterEmailFlow(action) {
  const { token } = action.payload;
  try {
    const {
      applicationName, // the purpose of application-name is to indicate where users come from
      firstName,
      lastName,
      id,
      countryCode,
      username,
      email,
      profilePicUrl: avatar,
      role: { name: role },
      region,
      phone,
      jwt,
    } = yield call(apiCheckConfirmEmailToken, token);

    const profile = {
      applicationName,
      userId: id.toString(),
      username,
      email,
      role,
      firstName,
      lastName,
      countryCode,
      avatar,
      region: region.name,
      phone,
    };

    const snapCookie = new cookie(COOKIE_DOMAIN);
    snapCookie.saveCookieFromAuthInfo(profile);
    snapCookie.updateUserToken(jwt);

    // store profile info
    yield put(storeProfile(profile));
    yield put(loginSuccess(jwt));

    yield put(
      sendGtmEvent({
        eventName: COMPLETE_REGISTRATION,
        data: {
          content_name: profile.role,
          currency: region.fullName,
          value: id,
          provider: EMAIL,
        },
      })
    );

    yield put(
      sendGtmEvent({
        eventName: EVENT_COMPLETED_REGISTRATION,
        data: {
          sourceType: EMAIL,
        },
      })
    );

    const redirectPage = getRedirectPage();
    if (redirectPage) return yield put(openExternalUrl(redirectPage));

    yield put(actions.confirmEmailSuccess());
  } catch (err) {
    yield put(actions.confirmEmailError(err.message));
  }
}

export function* confirmUpdatedEmailFlow(action) {
  const { token } = action.payload;
  try {
    const {
      user: {
        firstName,
        lastName,
        snapaskUid: id,
        countryCode,
        username,
        email,
        profilePicUrl: avatar,
        role: { name: role },
        region: { name },
        phone,
        jwt,
      },
    } = yield call(apiCheckUpdatedEmailToken, token);

    const profile = {
      userId: id.toString(),
      username,
      email,
      role,
      firstName,
      lastName,
      countryCode,
      avatar,
      region: name,
      phone,
    };

    const snapCookie = new cookie(COOKIE_DOMAIN);
    snapCookie.saveCookieFromAuthInfo(profile);
    snapCookie.updateUserToken(jwt);

    // store profile info
    yield put(storeProfile(profile));
    yield put(actions.confirmEmailSuccess());
  } catch (err) {
    yield put(actions.confirmEmailError(err.message));
  }
}
export default function*() {
  yield all([
    takeLatest(actions.CONFIRM_REGISTER_EMAIL, confirmRegisterEmailFlow),
    takeLatest(actions.CONFIRM_UPDATED_EMAIL, confirmUpdatedEmailFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/confirmEmail.js